import { MusicAudio } from '@/config/AudioConfig'
import AudioEngine from '@/webgl/audio/AudioEngine'
import AudioMusic from '@/webgl/audio/AudioMusic'
import { TimeEntity } from '@/webgl/runner/entities/Time'
import GameWorld from '@/webgl/runner/GameWorld'
import { ISystem } from '@/webgl/runner/interfaces/ISystem'

export default class MusicSystem implements ISystem {
  music: AudioMusic
  constructor(readonly world: GameWorld) {
    this.music = AudioEngine.instance.music
  }

  start(): void {
    this.music.play('TYCE_MUSIC_runner')
  }

  play(id: string) {
    this.music.play(id)
  }

  update(time: TimeEntity): void {
    const jauge = this.world.state.value.jauge
    this.music.getLayer('TYCE_MUSIC_runner').getTrack(MusicAudio.Runner_A).gain.gain.value = 1.0
    this.music.getLayer('TYCE_MUSIC_runner').getTrack(MusicAudio.Runner_B).gain.gain.value = jauge * jauge
  }

  dispose(): void {}
}
